import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'kt-toe-exclude-dialog',
  templateUrl: './toe-exclude-dialog.component.html',
  styleUrls: ['./toe-exclude-dialog.component.scss']
})
export class ToeExcludeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ToeExcludeDialogComponent>,
  ) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
